import { 
    apiGetHouseStatus,
    apiGetCounty,
    apiGetDistrict,
    apiGetRoad,
} from "@/apis/api.js"; 

/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_filter_query: 'houseStatus/set_filter_query',
    set_district_house_uid: 'houseStatus/set_district_house_uid',
    set_house: 'houseStatus/set_house',
    set_county: 'houseStatus/set_county',
    set_district: 'houseStatus/set_district',
    set_road: 'houseStatus/set_road',
    set_loading: 'houseStatus/set_loading'
}

// count state 必須是 Object
const state = {
    filterQuery: {
                country: '',
                county: '',
                district: '',
                empty: ['0','1'],
                status: ['0','1','2','3','4','5'],
                leaseTerm: [],
                houseType: '',
                buildingType: '',
                rent: [0, 100000],
            },
    houseResult: [],
    districtHouseUid: '',
    county: [],
    districts: [],
    road: [],
    defaultFilterStatus: [0,1,2,3,4,5],
    isLoading: false
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    FILTER_QUERY: (state) => {
        return state.filterQuery
    },
    FILTER_RESULT: (state) => {
        return state.filterResult
    },
    HOUSE_RESULT: (state) => {
        return state.houseResult
    },
    COUNTY_RESULT: (state) => {
        return state.county
    },
    DISTRICTS_RESULT: (state) => {
        return state.districts
    },
    ROAD_RESULT: (state) => {
        return state.road
    },
    DISTRICT_HOUSE_UID: (state) => {
        return state.districtHouseUid
    },
    HOUSE_STATUS_LOADING: (state) => {
        return state.isLoading
    },
    DEFAULT_FILTER_STATUS: (state) => {
        return state.defaultFilterStatus
    }
}

// actions 也是以 Object 形式建構。
const actions = {
    getHouse ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_loading, true);
            apiGetHouseStatus()
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    let value = res.data.result.location
                    commit(types.set_house, value);
                    commit(types.set_loading, false);
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
            resolve()
        })
    },
    getCounty ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            apiGetCounty()
            .then(res => {
                // console.log(res)
                if( res.data.status == "SUCCESS" ){
                    let value = res.data.result.data
                    commit(types.set_county, value);
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
            resolve()
        })
    },
    getDistrict ( {commit} , data ) {
        return new Promise((resolve, reject) => {
            console.log(data)
            apiGetDistrict(data)
            .then(res => {
                // console.log(res)
                if( res.data.status == "SUCCESS" ){
                    let value = res.data.result.districtVoList
                    commit(types.set_district, value);
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    getRoad ( {commit} , data ) {
        return new Promise((resolve, reject) => {
            apiGetRoad(data)
            .then(res => {
                // console.log(res)
                if( res.data.status == "SUCCESS" ){
                    let value = res.data.result.roadVoList
                    commit(types.set_road, value);
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    setFilterHouse ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            if(value != ''){
                commit(types.set_filter_query, value);
            }
            resolve()
        })
    },
    setDistrictHouseUid ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            if(value != ''){
                commit(types.set_district_house_uid, value);
            }
            resolve()
        })
    },
}

// mutations
const mutations = {
    [types.set_filter_query](state, query){
        state.filterQuery = query
    },
    [types.set_district_house_uid](state, uid){
        state.districtHouseUid = uid
    },
    [types.set_house](state, data){
        state.houseResult = data
    },
    [types.set_county](state, data){
        state.county = data
    },
    [types.set_district](state, data){
        state.districts = data
    },
    [types.set_road](state, data){
        state.road = data
    },
    [types.set_loading](state, data){
        state.isLoading = data
    }
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/landlord/houseStatus.js